"use strict";

define('rs/models/training',['require','exports','module','rs/models/abstract'],function (require, exports, module) {
  var AbstractModel = require('rs/models/abstract');
  var TrainingModel = AbstractModel.extend({
    properties: ['expirationDate', 'completedDate', 'status', 'course', 'group', 'stage'],
    serverProperties: ['tenant_id', 'member_id', 'first_name', 'last_name', 'email', 'curriculum', 'group', 'stage', 'completed_date', 'expiration_date', 'username', 'cr_number', 'module_completion_date', 'module', 'exam_id', 'exam_score', 'is_hidden', 'completed_date_timestamp', 'expiration_date_timestamp'],
    CURRENT: 'Current',
    EXPIRED: 'Expired',
    initialize: function initialize() {
      this._super.apply(this, arguments);
      this.setCourse(this.curriculum);
      this.setStatus(this.determineStatus(this.expiration_date_timestamp));
      if (this.expiration_date_timestamp) {
        this.setExpirationDate(new Date(this.expiration_date_timestamp).toLocaleDateString());
      }
      if (this.completed_date_timestamp) {
        this.setCompletedDate(new Date(this.completed_date_timestamp).toLocaleDateString());
      }
    },
    determineStatus: function determineStatus(expirationDateTimestamp) {
      if (!expirationDateTimestamp) {
        return '';
      }
      var expDate = parseInt(expirationDateTimestamp, 10);
      if (expDate > Date.parse(new Date())) {
        return this.CURRENT;
      } else {
        return this.EXPIRED;
      }
    }
  }, {
    rootURI: '/rs/citi',
    model: function model(data) {
      return new TrainingModel(data);
    },
    parsers: {
      '#GET#(?*query)': function GETQuery(data) {
        return this.models(data);
      }
    },
    requestDetails: function requestDetails(email) {
      return this.get('?email=' + encodeURIComponent(email));
    }
  });
  module.exports = TrainingModel;
});

